/**
 * @prettier
 */

import { useTranslation, Trans } from "react-i18next";
import { isMobile, isTablet } from "react-device-detect";
import CustomButton from "../../../components/CustomButton";
import InstructionsIcon from "./InstructionsIcon";
import backArrowIcon from "../../../assets/img/back_arrow_icon.png";

// Removes backslash from string
const sanitiseString = string => string.replace(/\\/g, " ");

const PrepareToUploadState = ({
    primaryFocusRef,
    title,
    subTitle,
    handleStartCamera,
    handleSelectFiles,
    handleBackButton,
    brandingColor,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <h1 className="page-title" ref={primaryFocusRef} tabIndex={0}>
                <Trans
                    i18nKey="idpal_proof_of_address_title_v2"
                    values={{ documentType: sanitiseString(title) }}
                    components={{
                        br: <br />,
                    }}
                />
            </h1>
            {subTitle && subTitle.length > 0 && (
                <h2 className="page-subtitle">{sanitiseString(subTitle)}</h2>
            )}
            <div className="image-wrapper">
                <InstructionsIcon fill={brandingColor} />
            </div>

            <div className="cta-container">
                {isMobile || isTablet ? (
                    <>
                        <CustomButton
                            type="customHover"
                            className={"btn outline"}
                            label={t("idpal_capture_poa")}
                            handleClick={handleStartCamera}
                        />
                        <CustomButton
                            className="btn"
                            label={t("idpal_upload_poa")}
                            handleClick={handleSelectFiles}
                            outlined
                        />
                    </>
                ) : (
                    <CustomButton
                        type="customHover"
                        className={"btn outline"}
                        label={t("idpal_upload_poa")}
                        handleClick={handleSelectFiles}
                    />
                )}
            </div>
            {handleBackButton && (
                <div className="back-button-container-section">
                    <button
                        className="select-different-doc-btn"
                        onClick={() => {
                            handleBackButton();
                        }}
                    >
                        <img
                            src={backArrowIcon}
                            alt="Back arrow"
                            className="back-arrow-icon"
                        />
                        <span>{t("idpal_select_different_document")}</span>
                    </button>
                </div>
            )}
        </>
    );
};
export default PrepareToUploadState;
